import React from "react";
import { skipContentStyle } from "../styles";

const SkipToMain: React.FC = () => {
  return (
    <button
      className={skipContentStyle}
      onClick={() => document.getElementById("maincontent")?.focus()}
    >
      Skip to main content
    </button>
  );
};

export default SkipToMain;
